import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

/* Ada pins its 56px chat launcher 20px in from the bottom-right corner. Reserving that
   corner stops the left-aligned row from running under it once the row fills the width;
   while the row still has slack the reserved space is invisible. */
const CHAT_LAUNCHER_CLEARANCE = "84px";

export const footer = (theme: Theme, isLeftAligned: boolean) => css`
  display: flex;
  justify-content: ${isLeftAligned ? "flex-start" : "center"};
  align-items: center;
  gap: ${isLeftAligned ? theme.ds5.spacing.gap.small : "0"};
  padding: 1rem ${isLeftAligned ? CHAT_LAUNCHER_CLEARANCE : "0"} 1.5rem 0;
  border-top: 1px solid ${theme.system.borderBase};

  @media (max-width: ${dimensions.phoneLargeMax}) {
    flex-wrap: wrap;
    margin-top: 0;
    padding-left: ${isLeftAligned ? "2rem" : "0"};
    padding-right: ${isLeftAligned ? "2rem" : "0"};
  }
`;

export const privacyPolicy = (isLeftAligned: boolean) => css`
  width: ${isLeftAligned ? "auto" : "100%"};
  text-align: ${isLeftAligned ? "left" : "center"};
  padding: 1rem 0.5rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    flex: ${isLeftAligned ? "1 1 0" : "0 1 auto"};
  }
`;

export const footerLogos = css`
  margin-left: 2rem;
`;
